import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * Extract just "Q1" from QuarterName which may be "FY26 Q1" or just "Q1".
 */
function extractQ(name) {
  if (!name) return '';
  const m = name.match(/Q\d+/i);
  return m ? m[0] : name;
}

/**
 * Format a quarter object into a readable label.
 * e.g. "Q1 2026"
 */
export function formatQuarterLabel(q) {
  if (!q) return '';
  const qName = extractQ(q.QuarterName);
  const fy = q.FiscalYear || '';
  return fy ? `${qName} ${fy}` : q.QuarterName || '';
}

/**
 * Short quarter label without year, e.g. "Q1"
 */
export function formatQuarterShort(q) {
  if (!q) return '';
  return extractQ(q.QuarterName);
}